<div
	class="flex flex-row items-center justify-start"
	matDialogTitle
>
	<span>{{ 'TimeRounding' | translate }}</span>
	<div class="flex-auto"></div>
	<button
		mat-icon-button
		matDialogClose
		tabindex="-1"
	>
		<mat-icon>close</mat-icon>
	</button>
</div>
<mat-dialog-content>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.roundingGrp"
		class="my-4 flex flex-col gap-6"
	>
		<div
			*ngIf="!hideToggle"
			class="mx-1 flex flex-row items-center justify-start"
		>
			<span>{{ 'RoundingOn' | translate }}</span>
			<div class="flex-auto"></div>
			<mat-slide-toggle
				color="primary"
				formControlName="roundingState"
			></mat-slide-toggle>
		</div>
		<div class="flex flex-row items-center justify-start gap-4">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-plain mat-form-field-compact wflex-auto"
			>
				<mat-select
					formControlName="roundingType"
					placeholder="Round Type"
				>
					<mat-option
						[value]="rType"
						*ngFor="let rType of roundingTypes"
					>
						{{ parseDisplayRoundingType(rType) | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field
				appearance="fill"
				class="mat-form-field-plain mat-form-field-compact wflex-auto"
			>
				<mat-select
					*ngIf="durArray as dur"
					formControlName="roundingValue"
					placeholder="Round Value"
				>
					<mat-option
						[value]="d"
						*ngFor="let d of dur.values"
					>
						{{ d * 60 * 1000 | dfnsFormatDistanceStrict: dur.ref }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>
<mat-dialog-actions class="mat-action-filled flex flex-col">
	<button
		(click)="this.submit()"
		class="mat-action-filled self-stretch"
		color="primary"
		mat-flat-button
	>
		{{ 'utils.apply' | translate }}
	</button>
</mat-dialog-actions>
